<template>
        <div class="item-container company-add-form popup-shadow" :class="getClasses">
            <div class="tab-header-container">
                <h2 class="form-label">{{company ? 'Редактиране' : 'Добавяне'}} на фирма</h2>
                <LiteButton @click.native="close"
                            v-show="company && company.id"
                            style="font-size: 35px; float: right;"
                            class="edit-button"
                            :hoverColor="'red'"
                            :icon="'far fa-window-close'">
                </LiteButton>
            </div>

            <hr class="form-line">

            <form>
                <InputText class="company-input"
                           @value-change="setAttribute"
                           :id="'name'"
                           :name="'name'"
                           :label="'Име'"
                           :initialValue="company ? company.name : null"
                           :placeholder="'Въведете име'"
                           :newValue="newCompany.name"
                           :showError="shouldShowError('name')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('name')" :text="errors['name']"></ErrorInput>

                <InputText class="company-input"
                           @value-change="setAttribute"
                           :id="'address'"
                           :name="'address'"
                           :label="'Адрес'"
                           :initialValue="company ? company.address : null"
                           :placeholder="'Въведете адрес'"
                           :newValue="newCompany.address"
                           :showError="shouldShowError('address')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('address')" :text="errors['address']"></ErrorInput>

                <SelectDropDown v-if="countries"
                                class="company-input"
                                :id="getDropdownId"
                                :name="'countryDropdown'"
                                :options="countries"
                                :defaultSelected="countries[0]"
                                :label="'Държава'"
                                @selection-change="countrySelected"
                />

                <Button class="save-company-button"
                        @click.native="saveCompany"
                        :color="'green'"
                        :text="'Запази'"
                        :icon="'fa fa-save'"></Button>
            </form>
        </div>
</template>

<script>
    import Button from "@/shared/components/button/Button";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import sharedService from "@/services/shared.service";
    import InputText from "@/shared/components/form/InputText";
    import LiteButton from "@/shared/components/button/LiteButton";
    import SelectDropDown from "@/shared/components/form/SelectDropDown";

    export default {
        name: "CompanyEdit",
        components: {SelectDropDown, LiteButton, InputText, Button, ErrorInput},
        props: {
            company: Object
        },
        created() {
            sharedService.fetchCountries()
                .then(({data}) => {
                    data.map((country) => {
                        const tempCountry = country;
                        tempCountry.id = country.iso;
                        return tempCountry;
                    });
                    this.countries = data;
                    this.selectedCountry = data[0];
                });

            if (this.company && this.company.id) {
                this.newCompany = this.company;
            }
        },
        data() {
            return {
                gridData: [],
                isLoading: true,
                newCompany: {
                    name: null,
                    address: null,
                    country: null
                },
                countries: null,
                selectedCountry: null,
                errors: {}
            }
        },
        methods: {
            setAttribute(value) {
                this.errors[value.name] = null;
                this.newCompany[value.name] = value.currentValue;
            },
            countrySelected(value) {
                this.selectedCountry = value.currentValue;
            },
            saveCompany() {
                this.newCompany.country = this.selectedCountry;
                if (this.company && this.company.id) {
                    sharedService.updateCompany(this.newCompany)
                        .then(() => {
                            this.companySaved()
                        })
                        .catch((errors) => this.errors = errors.response.data.errors);

                } else {
                    sharedService.addCompany(this.newCompany)
                        .then(() => {
                            this.companySaved()
                        })
                        .catch((errors) => this.errors = errors.response.data.errors);
                }
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            },
            companySaved() {
                this.$emit('saved-company');
                this.newCompany = {name: '', code: ''};
            },
            close() {
                this.$emit('close-clicked', {});
            }
        },
        computed: {
            getClasses() {
                return this.company && this.company.id ? 'company-modal-form' : '';
            },
            getDropdownId() {
                if (this.company && this.company.id) {
                    return 'countryDropdown_edit';
                }
                return 'countryDropdown_add';
            }
        }
    }
</script>

<style scoped>
    @import '../../css/shared/tabs.css';

    .company-modal-form {
        z-index: 120;
        position: absolute;
        background-color: #ffffff;
        top: 100px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .company-input {
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .save-company-button {
        width: 220px;
        height: 50px;
        font-size: 25px;
        margin: 45px;
    }

    .company-add-form {
        width: 600px;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }
</style>
